<template>
<v-container v-show="cargando = true">
  <v-card elevation="16" >
  <v-card-title class="justify-center">{{titulo}}</v-card-title>
  <v-card-text style="text-align:center;">{{texto}}</v-card-text>
  </v-card>
</v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
export default {
  data() {
    return{
      archivo: "",
      titulo: "El archivo se esta descargando.",
      texto: "El archivo que se ha solicitado se esta descargando, si necesitas algún otro, ponte en contacto con tu distribuidor de Equinsa Parking",
      cargando: false
    }
  },
  methods:{
    //Obtenemos los parametros de la url
    obtenerParametrosUrl() {
      var url = window.location.search;
      var urlParametros = new URLSearchParams(url);
      let tokenSAGA = urlParametros.get("token");
      this.archivo = urlParametros.get("archivo");
      if (!tokenSAGA)
        this.$router.push({ path: "/" });

      return tokenSAGA;
    },
    //Comprobamos la validez del token segun hayan indicado de tiempo
    comprobarValidezToken (token) {
      ApiZD.descargarArchivoCompartido(token,this.archivo)
      .then((res)=>{
        if(res.status != 200){
          this.titulo = "Hemos tenido un problema al descargar el archivo "+ this.archivo;
          this.texto = "Se ha detectado un problema al descargar el archivo. Refresca la pagina y si no se descarga, ponte en contacto con tu distribuidor para que te solicite un nuevo archivo";
        }
      })
      .finally(()=>{
        this.cargando = true;
      })

    },

  },
  created () {
    this.comprobarValidezToken(this.obtenerParametrosUrl());
  }
}
</script>

<style>

</style>